import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e9a24b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content" }
const _hoisted_2 = ["src"]

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getPlayerData, getRequire } from './unit'
import PanelData from './PanelData.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
let { name, type, category } = route.query

let playerList: any[] = getPlayerData().positionslist
let conterName = name
let conterType = ref(type)
const pagePath = ref()
const btnTxt = ref('')
const setPagePath = (name, type) => {
    if (category == 'Player') {
        pagePath.value = 'women-world-cup-personal-summary/中国女篮世预赛总结/' + name + '/' + type + '.html'
    } else {
        pagePath.value = 'women-world-cup-personal-summary/球队总结/' + name + '/' + type + '.html'
    }
}

onMounted(() => {
    next(2)
})

const geneIframe = () => {
    var script = document.createElement('script')
    script.type = 'text/javascript'

    var code = `function audioAutoPlay(){
                var audios = document.getElementsByTagName("video");
                console.log('audios====', audios);
                var play = function(){
                    audios[0].play();
                    audios[0].pause();
                    document.removeEventListener("touchstart",play, false);
                };
                document.addEventListener("touchstart",play, false);
            }
            audioAutoPlay()
            `
    script.appendChild(document.createTextNode(code))
    var ifr = document.getElementById('ifr')!
    var ifrDoc
    if (!ifr) return
    ifr.onload = function () {
        ifrDoc = (ifr as HTMLIFrameElement).contentWindow?.document
        var last = ifrDoc?.lastChild
        last!.appendChild(script)
    }
}

const next = (nextType) => {
    if (category == 'Team') {
        TeamNext(nextType)
        return
    }
    let typeList = ['表现总结', '有待改进细节', '详细视频拆解', '未来发展方向']
    let typeIndex = typeList.findIndex((item: any) => {
        return item == conterType.value
    })
    let playerIndex = playerList.findIndex((item: any) => {
        return item.name == name
    })
    if (nextType == 2) {
        setPagePath(name, type)
        if (typeIndex >= typeList.length - 1) {
            btnTxt.value = '点击查看下一个球员'
            if (playerIndex >= playerList.length - 2) {
                btnTxt.value = '回到首页'
            }
        } else {
            btnTxt.value = '点击查看下一页'
        }
        return
    }
    if (typeIndex >= typeList.length - 2) {
        btnTxt.value = '点击查看下一个球员'
    } else {
        btnTxt.value = '点击查看下一页'
    }

    if (typeIndex >= typeList.length - 1) {
        if (playerIndex >= playerList.length - 2) {
            btnTxt.value = '回到首页'
        }
        if (playerIndex >= playerList.length - 1) {
            router.replace({
                name: 'worldCupQualifier',
                query: {},
            })
        } else {
            router.go(-1)
            router.replace({
                name: 'PlayerPersonal',
                query: {
                    currentPlayer: JSON.stringify(playerList[playerIndex + 1]),
                },
            })
        }
    } else {
        conterType.value = typeList[typeIndex + 1]
        setPagePath(name, conterType.value)
        geneIframe()
    }
}
const TeamNext = (nextType) => {
    let typeList = ['表现总结', '有待改进细节', '未来发展方向']
    let typeIndex = typeList.findIndex((item: any) => {
        return item == conterType.value
    })
    if (nextType == 2) {
        setPagePath(name, type)
        if (typeIndex >= typeList.length - 1) {
            btnTxt.value = '返回球队赛后总结'
        } else {
            btnTxt.value = '点击查看下一页'
        }
        return
    }
    if (typeIndex >= typeList.length - 2) {
        btnTxt.value = '返回球队赛后总结'
    } else {
        btnTxt.value = '点击查看下一页'
    }

    if (typeIndex >= typeList.length - 1) {
        router.go(-2)
    } else {
        conterType.value = typeList[typeIndex + 1]
        setPagePath(name, conterType.value)
        geneIframe()
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(conterType) == '详细视频拆解')
        ? (_openBlock(), _createBlock(PanelData, { key: 0 }))
        : (_openBlock(), _createElementBlock("iframe", {
            id: "ifr",
            key: pagePath.value,
            class: "iframe",
            src: pagePath.value,
            frameborder: "0",
            importance: "high"
          }, null, 8, _hoisted_2))
    ]),
    _createElementVNode("div", {
      class: "next-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (next(1)))
    }, _toDisplayString(btnTxt.value), 1)
  ]))
}
}

})